import React, { useState } from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { Form, Dropdown, ButtonGroup } from "react-bootstrap";
import { useSelector } from "react-redux";
import globalConstants from "../shared/appConfig/globalConstants";

const { Apply, Reset } = globalConstants.ButtonLabels;

const DashboardFilter = ({
	onSearch,
	clearSearch,
	filterStatusString,
	resetFilters,
	applyFilters,
	/** When true, search + filter are flattened for CSS grid in Delivery List title row (Figma). */
	tableTitleGrid = false,
}) => {
	const [dropdownVisibility, setDropdownVisibility] = useState(false);

	const { appSetting } = useSelector((state) => state.common);
	const optionValues = appSetting.PartnerLocationSettings
		?.CustomerDelScheduleSmsResponse
		? [
			"Awaiting Customer Confirmation",
			"Scheduled",
			"In-Progress",
			"Completed",
			"Canceled",
		]
		: ["Scheduled", "In-Progress", "Completed", "Canceled"];

	/**
	 * checkUncheckAll()
	 * This function is triggered on click of uncheck checkbox.
	 */
	const checkUncheckAll = () => {
		try {
			let selectAllCheckboxes = document.getElementById("checkUncheckAll");
			var checkboxes = document.getElementsByName("deliveryStatus");
			if (selectAllCheckboxes.checked === true) {
				checkboxes.forEach((item) => {
					item.checked = true;
				})
			} else {
				checkboxes.forEach((item) => {
					item.checked = false;
				})
			}
		} catch (err) {
			console.log(err);
		}
	};

	/**
	 * handleChange()
	 * This function is triggered on click of each filter from the filter list
	 */
	const handleChange = async (event) => {
		try {
			document.getElementById(event.target.id).setAttribute("checked", "false");
			let checkboxes = document.getElementsByName("deliveryStatus");
			let selectAllCheckboxes = document.getElementById("checkUncheckAll");
			let checkboxesChecked = [];
			for (let index = 0; index < checkboxes.length; index++) {
				if (checkboxes[index].checked) {
					checkboxesChecked.push(checkboxes[index].id);
				}
			}
			if (checkboxesChecked.length === checkboxes.length) {
				selectAllCheckboxes.checked = true;
			} else {
				selectAllCheckboxes.checked = false;
			}
		} catch (err) {
			console.log(err);
		}
	};

	/**
	* onApplyFilter()
	* This function is used to fetch filtered data.
	*/
	const onApplyFilter = (event) => {
		setDropdownVisibility(false)
		applyFilters(event);
	}

	/**
	* onResetFilter()
	* This function is used to reset added filters.
	*/
	const onResetFilter = (event) => {
		setDropdownVisibility(false)
		resetFilters(event);
	}

	/**
	* CustomToggle()
	* This is to show/hide filter dropdown.
	*/
	const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
		<div
			ref={ref}
			onClick={(e) => {
				e.preventDefault();
				setDropdownVisibility(!dropdownVisibility);
			}}
			className="caret filter"
		>
			{children}
		</div>
	));

	const filterDropdown = (
		<div className="dashboard-filter-toolbar__filter-col">
			<Dropdown className="filterDropdown" show={dropdownVisibility}>
				<ClickAwayListener onClickAway={() => setDropdownVisibility(false)}>
					<div>
						<Dropdown.Toggle as={CustomToggle} id="dropdown-basic">
							<span>Filter:</span>{" "}
							{filterStatusString.length === optionValues.length
								? "All"
								: filterStatusString.join(", ")}
						</Dropdown.Toggle>
						<Dropdown.Menu>
							<div className="inner-content">
								<Form.Group controlId="checkbox">
									<Form.Check
										type="checkbox"
										name="checkUncheckAll"
										label="Check / uncheck all"
										id="checkUncheckAll"
										defaultChecked={false}
										onChange={(event) => checkUncheckAll(event)}
									/>
								</Form.Group>
								{optionValues.map((item, index) => (
									<Form.Group
										controlId={
											appSetting.PartnerLocationSettings
												.CustomerDelScheduleSmsResponse
												? index
												: index + 1
										}
										key={item}
									>
										<Form.Check
											type="checkbox"
											name="deliveryStatus"
											label={item}
											value={item}
											defaultChecked={
												item === filterStatusString[index] ? true : false
											}
											onChange={handleChange}
										/>
									</Form.Group>
								))}
								<ButtonGroup>
									<button type="button" className="btn" onClick={onApplyFilter}>
										{Apply}
									</button>
									<button type="button" className="btn btn-reset" onClick={onResetFilter}>
										{Reset}
									</button>
								</ButtonGroup>
							</div>
						</Dropdown.Menu>
					</div>
				</ClickAwayListener>
			</Dropdown>
		</div>
	);

	const searchInput = (
		<div className="search">
			<input
				label="Search"
				maxLength="99"
				name="searchText"
				autoComplete="off"
				id="searchText"
				className="searchText"
				placeholder="Search"
				onKeyDown={onSearch}
			/>
			<link onClick={clearSearch} id="closeIcon"></link>
		</div>
	);

	if (tableTitleGrid) {
		return (
			<div className="dashboard-filter-toolbar dashboard-filter-toolbar--table-title-grid">
				{searchInput}
				{filterDropdown}
			</div>
		);
	}

	return (
		<div className="dashboard-filter-toolbar">
			<div className="dashboard-filter-toolbar__controls">
				{searchInput}
				{filterDropdown}
			</div>
		</div>
	);
};

export default DashboardFilter;
